import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { hotelCollabs } from '../collabdata';
import './HotelCollabs.css';

export default function CollaborationDetail() {
  const { hotelId } = useParams();
  const navigate = useNavigate();
  const hotel = hotelCollabs.find(h => h.id === hotelId);
  
  const [activeHeroIdx, setActiveHeroIdx] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!hotel) return <div className="detail-view" style={{padding: '100px', textAlign: 'center'}}>Property Not Found</div>;

  const nextHero = () => {
    setActiveHeroIdx((prev) => (prev === hotel.heroImages.length - 1 ? 0 : prev + 1));
  };

  const prevHero = () => {
    setActiveHeroIdx((prev) => (prev === 0 ? hotel.heroImages.length - 1 : prev - 1));
  };

  return (
    <div className="collab-page-wrapper">
      
      {/* FULL SCREEN HERO SLIDER */}
      <section className="detail-hero-fullscreen">
        <div className="hero-slider-track">
          {hotel.heroImages.map((img, idx) => (
            <div 
              key={idx} 
              className={`hero-slide ${activeHeroIdx === idx ? 'active' : ''}`}
              style={{ backgroundImage: `url(${img})` }}
            />
          ))}
        </div>

        {/* Floating Header UI */}
        <button onClick={() => navigate(-1)} className="back-pill-btn">← Return to Hub</button>
        
        <div className="hero-text-center">
          <span className="location-badge">{hotel.location}</span>
          <h1 className="hero-title-main">{hotel.name}</h1>
          {/*<p className="hero-date">🗓️ {hotel.timeline}</p>*/}
        </div>

        {/* Bottom Controls */}
        <div className="hero-footer-controls">
          <button className="nav-arrow" onClick={prevHero}>‹</button>
          <div className="pagination-dots">
            {hotel.heroImages.map((_, i) => (
              <span 
                key={i} 
                className={`p-dot ${activeHeroIdx === i ? 'active' : ''}`} 
                onClick={() => setActiveHeroIdx(i)} 
              />
            ))}
          </div>
          <button className="nav-arrow" onClick={nextHero}>›</button>
        </div>
      </section>

      {/* Content Section starts after the fold */}
      <div className="detail-content-body">
        <div className="detail-main-content">
          <h2 className="section-title-serif">The Collaboration</h2>
          <p className="narrative-text">
            TravXplo collaborated with <strong>{hotel.name}</strong> to architect a premium digital narrative. 
            Through the lens of <strong>{hotel.creator}</strong>, the campaign captured the unique soul of the property.
          </p>
          {hotel.website && (
            <a href={hotel.website} target="_blank" rel="noreferrer" className="btn-premium-outline luxury-center-btn">
              Visit Property Website
            </a>
          )}
        </div>

        <div className="info-grid-wrapper">
          <div className="detail-grid-container">
            <div className="info-card-lux">
              <h4 className="card-label-gold">Lead Creator</h4>
              <p className="card-main-val">{hotel.creator}</p>
              <a href={hotel.creatorLink} target="_blank" rel="noreferrer" className="btn-premium-outline">
                View Instagram
              </a>
            </div>

            <div className="info-card-lux">
              <h4 className="card-label-gold">Campaign Content</h4>
              <div className="media-links-stack">
                {hotel.stories ? <a href={hotel.stories} target="_blank" rel="noreferrer" className="media-link-lux">Instagram Stories →</a> : <span className="media-disabled">Stories Unavailable</span>}
                {hotel.post ? <a href={hotel.post} target="_blank" rel="noreferrer" className="media-link-lux">Static Content →</a> : <span className="media-disabled">Post Unavailable</span>}
                {hotel.reel ? <a href={hotel.reel} target="_blank" rel="noreferrer" className="media-link-lux">Cinematic Reel →</a> : <span className="media-disabled">Reel Unavailable</span>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}